<template>
  <div id="notfound-container" :class="checkMobileStatus ? 'mobile-view' : 'web-view'">
    <div class="notfound-error">
      <div class="notfound-img">
        <img src="../../assets/404-1.png" />
      </div>

      <div class="notfound-content">
        <p>The page that you are looking for is <span>Not Found</span>.</p>
        <small>The link you followed may be broken, or the link may be removed.</small>

        <button class="btn btn-default"><a href="/src/pages/Public">Back to Home</a></button>
      </div>
    </div>
  </div>
</template>

<script>
// import Step from "../components/Step";
import DataSource from '../../data/datasource'

export default {
  name: 'notFound',
  data() {
    return {
      token: null,
      userType: null,
      list: [],
      results: '',

      checkMobileStatus: false,
    }
  },
  created() {
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
  async mounted() {
    this.isMobile()
  },
  methods: {
    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },
  },
}
</script>

<style scoped>
.web-view .notfound-error {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  border-radius: 14px;
  max-width: fit-content;
  margin: 20px auto;
}

.mobile-view .notfound-error {
  max-width: fit-content;
  margin: 20px auto;
}

.notfound-content > p {
  margin-bottom: 5px;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
}

.notfound-content > p > span {
  color: #426dff;
}

.notfound-content > small {
  color: #91a3b6;
  display: block;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}

.web-view .notfound-content > button {
  background: #426dff;
  border-radius: 39px;
  margin: 20px 0;
  padding: 5px 20px;
}

.mobile-view .notfound-content > button {
  background: #426dff;
  margin: 20px 0;
  padding: 5px 20px;
  width: 85%;
}

.notfound-content > button > a {
  color: #ffffff;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
}
</style>
